import React, { useEffect, useState } from 'react';

import Lottie from 'react-lottie';

const LottieHelper = (props) => {
	const [animationData, setAnimationData] = useState(null);

	useEffect(() => {
		const loadAnimation = async () => {
			try {
				const response = await fetch(`/lottie/${props.animationData}`);
				const data = await response.json();
				setAnimationData(data);
			} catch (error) {
				console.error('Error loading animation data:', error);
			}
		};

		loadAnimation();
	}, [props.animationData]);

	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};

	return (
		<div>
			<Lottie options={defaultOptions} />
		</div>
	);
};

export default LottieHelper;
